import { useEffect } from 'react';

/**
 * Lets a page shown without a login scroll the viewport with the mouse wheel.
 *
 * The global CSS gives `body` `overscroll-behavior: none` (no bounce or
 * pull-to-refresh in the signed-in shell, which scrolls inside its own panes)
 * and `overflow-x: hidden`, which makes body a scroll container of its own.
 * On a page that scrolls the viewport, Edge then refuses to chain a mouse
 * wheel from body to the page: it moves only by scrollbar or keyboard, so on
 * 2026-11-02 a client could not reach the Approve button on the valve
 * approval page (Chrome scrolled it). Setting body's overscroll-behavior back
 * to `auto` restores the wheel; the overflow resets match what the vendor
 * form has done since April. Restored on unmount.
 */
export function usePublicPageScroll(): void {
  useEffect(() => {
    const prev = {
      htmlOverflow: document.documentElement.style.overflow,
      bodyOverflow: document.body.style.overflow,
      bodyOverscroll: document.body.style.overscrollBehavior,
    };
    document.documentElement.style.overflow = 'auto';
    document.body.style.overflow = 'auto';
    document.body.style.overscrollBehavior = 'auto';
    return () => {
      document.documentElement.style.overflow = prev.htmlOverflow;
      document.body.style.overflow = prev.bodyOverflow;
      document.body.style.overscrollBehavior = prev.bodyOverscroll;
    };
  }, []);
}
